import { render } from "./ContentBase.vue?vue&type=template&id=3e03c258&scoped=true"
import script from "./ContentBase.vue?vue&type=script&lang=js"
export * from "./ContentBase.vue?vue&type=script&lang=js"

import "./ContentBase.vue?vue&type=style&index=0&id=3e03c258&scoped=true&lang=css"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e03c258"]])

export default __exports__